const introControl = {
    v: { 
        st_vid: null,
        st_txt: null,

        fState: null,
        fAnim: null,

        container: null,
        video: null,
        title: null,
    },
    init: function(){ 
        let t = this;
        let v = this.v;
        v.container = $(".site-wrapper .intro.homepage");
        if(v.container.length < 1) return true;
        v.video = v.container.find(".video");
        v.title = v.container.find(".intro__video h1");
        v.spinner = v.container.find(".spinning-words");
        t.makeAnim();

        let tmo = 0;
        window.addEventListener("resize", function(e){
            clearTimeout(tmo);
            tmo = setTimeout(t.makeAnim, 100);
        });
    },
    makeAnim: function(){
        let t = introControl;
        let v = t.v;
        if(v.st_vid !== null){
            t.killAnim();
        }

        if(window.innerWidth < 1024){
            v.video.removeClass("full");
            gsap.set([v.title, v.spinner], {autoAlpha:1});
            return true;
        }
        v.video.addClass("full");
        v.fState = Flip.getState(v.video, {kill:true});
        v.video.removeClass("full");
        v.fAnim = Flip.from(v.fState, {duration:1, ease:"none", simple:true});
        v.st_vid = ScrollTrigger.create({
            trigger:v.container.get(0),
            start: "top top",
            end: "bottom 50%",
            scrub: true,
            markers: false,
            animation: v.fAnim,
            pin: true,
        });

        v.st_txt = gsap.timeline({
            scrollTrigger: {
                trigger: v.container.get(0),
                start: "top top",
                end: "bottom 50%",
                scrub: true,
                markers: false,
                pin: true,
            }
        });
        v.st_txt.fromTo([v.title, v.spinner], {autoAlpha:0}, {autoAlpha:1, duration:1, ease:"none"}, 1);

    },
    killAnim: function(){
        let t = introControl;
        let v = t.v;
        v.st_vid.kill();
        v.st_txt.kill();
        Flip.killFlipsOf(v.video);
        v.video.attr("style", "");
    }
};